/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function RainbowCloud(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path
        d="M152,200c-13.25483,0-24-11.14314-24-24.88889s10.74517-24.88889,24-24.88889a23.18816,23.18816,0,0,1,8.81117,1.73087l-.00141-.0003A40.00363,40.00363,0,1,1,200,200Z"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={12}
      />
      <Path
        d="M16,176V160A96.00006,96.00006,0,0,1,178.92582,91.17453"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={12}
      />
      <Path
        d="M48,176V160a64.00543,64.00543,0,0,1,101.86674-51.60093"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={12}
      />
      <Path
        d="M80,176V160a32.02814,32.02814,0,0,1,39.42145-31.135"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={12}
      />
    </Svg>
  );
}

export default RainbowCloud;
